const isRecord = (value) =>
  value !== null && typeof value === "object" && !Array.isArray(value);

const normalizeErrorBody = (body) => {
  // Flask error envelope: {error: {code, message, fields}, request_id}
  if (isRecord(body) && isRecord(body.error)) {
    return {
      ...body,
      ...body.error,
      errors: body.error.fields || body.error.errors || {},
      error: body.error,
    };
  }
  if (isRecord(body)) {
    return { ...body };
  }
  return { message: typeof body === "string" && body.trim() ? body : "Request failed.", errors: {} };
};

export const getAppointmentUpdateResponseMessage = (response) => {
  if (typeof response === "string" && response.trim()) return response.trim();
  if (isRecord(response)) {
    if (typeof response.message === "string" && response.message.trim()) return response.message.trim();
    if (isRecord(response.error) && typeof response.error.message === "string" && response.error.message.trim()) {
      return response.error.message.trim();
    }
  }
  return "Unable to update the appointment. Please review the form and try again.";
};

export const extractAppointmentUpdateFailure = (action = {}) => {
  const payload = isRecord(action.payload) ? action.payload : {};
  const rawResponse = isRecord(payload.message) || typeof payload.message === "string"
    ? payload.message
    : payload;
  const response = normalizeErrorBody(rawResponse);
  const errorObject = isRecord(response.error) ? response.error : {};
  const errors = isRecord(response.errors)
    ? response.errors
    : isRecord(errorObject.fields)
      ? errorObject.fields
      : {};

  return {
    status: payload.status || null,
    response,
    errors,
    message: getAppointmentUpdateResponseMessage(response),
    booked: Array.isArray(response.booked)
      ? response.booked
      : Array.isArray(errorObject.booked)
        ? errorObject.booked
        : [],
  };
};
